export default {
  fontSize: '1.6rem',
  displayContainer: 'flex',
  justifyContent: 'space-between',
};
